import { Typography } from "@mui/material";
import { Accordion } from "src/components/UI/Accordion";
import { businessDetailsDescriptionSx } from "../../styles";
import { BusinessLocationInfo } from "./BusinessLocationInfo";
import { BusinessLocationContactInfo } from "./BusinessLocationContactInfo";

export const BusinessDetails = () => {
  return (
    <Accordion title="Business Details" defaultExpanded={true}>
        <Typography sx={businessDetailsDescriptionSx}>
          We&apos;ll submit the details below to your selected directories,
          including the Business Location contact name and email. Please review
          everything carefully to ensure it&apos;s accurate and complete before
          submission.
        </Typography>

        <BusinessLocationInfo />
        <BusinessLocationContactInfo />
      </Accordion>
  );
};